package com.evoapps.evoshift.navigation

import com.evoapps.evoshift.Route
import kotlin.reflect.KClass

/**
 * SH-180: the screens whose content must not land in the system's screenshots: Android's recents
 * thumbnail and screen recordings (`FLAG_SECURE`), the iOS app switcher's snapshot (a cover while
 * the app is inactive). Pay rates, contact details, documents, medical certificates, money.
 * [com.evoapps.evoshift.util.SecureScreenEffect] applies it for the screen on top of the stack.
 */
object SecureScreens {
    val routes: Set<KClass<out Route>> = setOf(
        // Money: the owner's figures and the employee's pay estimate.
        Route.Dashboard::class,
        Route.Financials::class,
        Route.DailyRecords::class,
        // SH-228: the sales statistics.
        Route.Statistics::class,
        Route.Payroll::class,
        Route.RecurringCosts::class,
        Route.SharedCosts::class,
        Route.Tips::class,
        Route.SalesImport::class,
        Route.Subscription::class,
        // Workplace finances: fixed revenue, commission, sales targets, payroll settings.
        Route.WorkplaceSettings::class,
        // People: pay rates, phone numbers, addresses, contracts, certificates, applicants' CVs.
        Route.Team::class,
        Route.EmployeeForm::class,
        Route.StaffImport::class,
        Route.Profile::class,
        Route.StaffDocuments::class,
        // SH-212: pay and contracts over time, OHS and medical exam dates.
        Route.EmployeeTimeline::class,
        Route.Applicants::class,
        // Health: absences with their reasons and medical certificates.
        Route.Absences::class,
        Route.Requests::class
    )

    /** Whether the screen on top ([route], null before the first one) needs the cover. */
    fun isSecure(route: KClass<out Route>?): Boolean = route != null && route in routes
}
